/**
 * Created on 2017/2/19.
 */
define('controllers/myaccount/new-earnings/account-new-earnings.ctrl',['app'], function (app) {
    app.controller('AccountNewEarningsCtrl', ['$q', '$scope', '$state', 'auiDialog',  'UserInfo',  'UserInfoPreload', '$location','invoiceService', 'modBussService','$rootScope','OpenUp','tenantsService',
        function ($q, $scope, $state, auiDialog, UserInfo, UserInfoPreload, $location, invoiceService,modBussService,$rootScope,OpenUp,tenantsService) {
            /* 2. $scope变量声明 */

            //判断是收益还是余额
            var states = $state.current.name.split('.');

            var Model=$scope.Model=
                {
                    tabUrls : ['new-earnings-settlement', 'new-earnings-dispute'],
                    tabs:[
                        {srf: 'MyAccount.newEarnings.settlement', title:("结算单")},
                        {srf: 'MyAccount.newEarnings.dispute', title:("争议处理")}
                    ],
                    showTip: true ,//展示老收益入口、页头提示
                    billType:states[1],
                    disputeType : states[2],
                    settlememtDescUrl :sysParamCfg.settlememtDescUrl,
                    settlememtGuideUrl:sysParamCfg.settlememtGuideUrl
                };
            $rootScope.getBussServiceAgreement = false;
            $rootScope.showBtnTip = true;//展示确认结算单按钮提示


                // 用于控制账单的二级菜单
            $scope.$on('transfer.myAccount', function(event, data) {
                var parsedURI = $location.url().split('/')[3];
                Model.selectedTab = Model.tabUrls.indexOf(parsedURI);
            });




            /* 3. $scope函数挂载 */



            /* 4. 初始化函数声明与执行 */
            !function () {
                var parsedURI = $location.url().split('/')[3];
                Model.selectedTab = Model.tabUrls.indexOf(parsedURI);
            }();
        }])
});
